import { getListBrowserStore } from '@ts-private/list-browser';

export const nonWorkingDaysStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'workingSiteId',
      caption: 'NonWorkingDays.WorkingSite',
      type: 'select',
      underlyingType: 'number'
    },
    {
      name: 'nonWorkingDayDate',
      caption: 'NonWorkingDays.Date',
      type: 'date'
    },
    {
      name: 'description',
      caption: 'NonWorkingDays.Description',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'NonWorkingDays.Date',
      value: 'nonWorkingDayDate'
    }
  ],
  pager: {
    orderBy: 'nonWorkingDayDate',
    direction: 'asc'
  }
});
